import { Card, Title1 } from "@fluentui/react-components";
import * as React from "react";

const AnnouncementsPage: React.FC = () => {
  return (
    <div>
        <Title1>Announcements</Title1>
        <p>Welcome to the Announcements page! Here you can find the latest news and updates about our product. Stay tuned for exciting features and improvements coming your way!</p>
        <Card>
          <Title1>New Features</Title1>
          <p>We are thrilled to announce the release of several new features that will enhance your experience:</p>
          <ul>
            <li><strong>Enhancements to the Reconciler</strong> The Reconciler now is even simpler to use and makes it easier to cycle through potential reconciling items.</li>
            <li><strong>More apps!</strong> The add-in now will support more than one app. The first in the new series is the Aggregate by color app, which lets you perform formulas like SUM on cells that match a certain color.</li>
            <li><strong>Custom functions</strong> The add-in now supports custom functions that can be used in Excel formulas. The first new custom function is the STATICRANDBETWEEN function, which only processes one interation.</li>
          </ul>
          <p>We hope you enjoy these new additions and look forward to your feedback!</p>
        </Card>
    </div>
  );
}

export default AnnouncementsPage;